import {createSlice} from "@reduxjs/toolkit";


const AuthSlice = createSlice({
    name: "AuthSlice",
    initialState: {
        isAuth: false,
        email: null,
        userId: null,
    },
    reducers: {
        loginUser(state, action) {
            state.email = action.payload.email;
            if (state.email) {
                state.isAuth = true;
            }
            state.userId = action.payload.userId
        },
        logout(state, action) {
            state.isAuth = false;
            state.email = null;
            state.email = null;
        }

    }
})


export const {loginUser, logout} = AuthSlice.actions;

export default AuthSlice.reducer;